import ResetCurrentPasswordPage from './ResetCurrentPasswordPageContainer';

export default ResetCurrentPasswordPage;
